import { useState, useCallback } from 'react';

/**
 * Custom hook for handling confirmation dialogs
 * Provides a promise-based API similar to window.confirm()
 */
export const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'warning',
    resolve: null
  });

  const showConfirmation = useCallback((options = {}) => {
    return new Promise((resolve) => {
      setConfirmationState({
        isOpen: true,
        title: options.title || 'Confirm Action',
        message: options.message || 'Are you sure you want to proceed?',
        confirmText: options.confirmText || 'Confirm',
        cancelText: options.cancelText || 'Cancel',
        type: options.type || 'warning',
        resolve
      });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    if (confirmationState.resolve) {
      confirmationState.resolve(true);
    }
    setConfirmationState(prev => ({ ...prev, isOpen: false, resolve: null }));
  }, [confirmationState.resolve]);

  const handleCancel = useCallback(() => {
    if (confirmationState.resolve) {
      confirmationState.resolve(false);
    }
    setConfirmationState(prev => ({ ...prev, isOpen: false, resolve: null }));
  }, [confirmationState.resolve]);

  return {
    confirmationState,
    showConfirmation,
    handleConfirm,
    handleCancel
  };
};

export default useConfirmation;
